<template>
  <div class="modal-popup">
    <div class="modal fade" id="routePopup" tabindex="-1" role="dialog"  aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content" v-if="route != null">
          <div class="modal-header">
            <h5 class="modal-title title" v-if="route.id != null">Güncelle</h5>
            <h5 class="modal-title title" v-if="route.id == null">Yarat</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true" class="la la-close"></span>
            </button>
          </div>
          <div class="modal-body">
            <div class="contact-form-action">
              <form method="post" id="sailRouteDetail">
                <div class="row">
                  <div class="col-sm-4">
                    <div class="input-box">
                      <label class="label-text">Bekleme Süresi</label>
                      <div class="form-group">
                        <input v-model="route.portingTime" disabled name="sailRoutePortingTime" class="form-control disabled" type="number" :placeholder="refresh">
                      </div>
                      <small v-if="showError" class="error">Lütfen kalkış varış saatlerini doğru girdiğinize emin olun.</small>
                    </div>
                  </div>
                  <div class="col-sm-8">
                    <div class="input-box">
                      <label class="label-text">Port <a v-if="route.portId != null" target="_blank" :href="basePath+'/ports/'+route.portId">#{{route.portId}}</a></label>
                      <div class="form-group">
                        <select v-model="route.portId" class="select-contain-select" name="sailRoutePort" type="text" placeholder="">
                          <option v-for="port in portList" :value="port.id"> {{port.name}} </option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-12">
                    <div class="input-box">
                      <label class="label-text">Kalkış Varış Zamanı</label>
                      <div class="form-group">
                        <input name="sailRouteDeparture" class="form-control departure" type="text" placeholder="">
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div><!-- end contact-form-action -->
          </div>
          <div class="modal-footer border-top-0 pt-0">
            <button type="button" class="btn font-weight-bold font-size-15 color-text-2 mr-2" data-dismiss="modal">İptal</button>
            <button v-if="route.id != null" :class="{'disabled' : !canPost}" @click="update" type="button" class="theme-btn theme-btn-small">Güncelle</button>
            <button v-if="route.id == null" :class="{'disabled' : !canPost}" @click="create" type="button" class="theme-btn theme-btn-small">Kaydet</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import generalValidation from "../../util/generalValidation";

export default {
  name: "SailRouteDetail",
  data:function (){
    return{
      canPost:false,
      showError:false,
      refresh:0
    }
  },
  computed:{
    route:{
      get(){
        return this.$store.getters.getRoute;
      }
    },
    sailRouteList:{
      get(){
        return this.$store.getters.getRouteList;
      }
    },
    portList:{
      get(){
        return this.$store.getters.getPortList;
      }
    },
    basePath:{
      get(){
        return this.$store.getters.getBasePath;
      }
    }
  },
  methods:{
    create(){
      if(this.canPost){
        if(this.route.portingTime > 0 && this.route.portId > 0){
          this.$store.dispatch("createRoute")
          .then(response => {
            $(".modal").modal('hide')
            Swal.fire({
              icon: 'success',
              title: 'Başarılı',
              text: '',
            })
            window.location.href = this.getters.getBasePath + "/sail/detail/" + this.$store.getters.getSail.id;
          })
        }else {
          this.showError = true;
        }
      }else{
        generalValidation.validForm("sailRouteDetail")
      }

    },
    update(){
      if(this.canPost){
        this.$store.dispatch("updateRoute", this.route)
        .then(response => {
          $(".modal").modal('hide')
          Swal.fire({
            icon: 'success',
            title: 'Başarılı',
            text: '',
          })
        })
      }else{
        generalValidation.validForm("sailRouteDetail")
      }
    },
    showDatePickerText(start,end){
      try {
        if(start == null){
          return null;
        }
        let startmm = start.getMonth();
        let startdd = start.getDate();
        if(startmm<10){
          startmm = "0"+startmm
        }
        if(startmm == "00"){
          startmm = 12;
        }
        if(startdd<10){
          startdd = "0"+startdd
        }
        return startdd+"/"+startmm+"/"+start.getFullYear() +" "+ start.getHour() +":"+start.getMinutes();
      }catch (E){

      }
      return null;

    },
    checkValid(){
      let that = this;
      setTimeout(function (){
        that.canPost = true;
        if(!generalValidation.checkForm("sailRouteDetail")){
          that.canPost = false;
        }
      },100);
    }
  },
  updated() {
    let that=this;
    setTimeout(function (){
      $(".select-contain-select").selectpicker('refresh');
      generalValidation.validateForm("sailRouteDetail")
      // $(".departure").focus();
    },100)
    $(".select-contain-select").selectpicker({
      size: 5,
      noneSelectedText: 'Lütfen liman seçiminizi yapın'
    });
    if(that.sailRouteList != null && that.sailRouteList.length > 1){
      $(".departure").daterangepicker({
        opens: 'right',
        timePicker: true,
        timePicker24Hour: true,
        "autoApply": true,
        startDate : that.route.arrivalDate,
        endDate : that.route.departureDate,
        minDate : new Date(that.sailRouteList[that.sailRouteList.length-1].departureDate),
        locale: {
          format: 'DD/MM/YYYY hh:mm',
          "applyLabel": "Onayla",
          "cancelLabel": "İptal",
          "daysOfWeek": [
            "Pa",
            "Pt",
            "Sa",
            "Ça",
            "Pr",
            "Cu",
            "Ct"
          ],
          "monthNames": [
            "Ocak",
            "Şubat",
            "Mart",
            "Nisan",
            "Mayıs",
            "Haziran",
            "Temmuz",
            "Ağustos",
            "Eylül",
            "Ekim",
            "Kasım",
            "Aralık"
          ]
        }
      });
    }else if(that.sailRouteList != null && that.sailRouteList.length == 1){
      $(".departure").daterangepicker({
        opens: 'right',
        timePicker: true,
        timePicker24Hour: true,
        "autoApply": true,
        startDate : new Date(),
        endDate : new Date(),
        minDate : new Date(that.sailRouteList[0].departureDate),
        locale: {
          format: 'DD/MM/YYYY hh:mm',
          "applyLabel": "Onayla",
          "cancelLabel": "İptal",
          "daysOfWeek": [
            "Pa",
            "Pt",
            "Sa",
            "Ça",
            "Pr",
            "Cu",
            "Ct"
          ],
          "monthNames": [
            "Ocak",
            "Şubat",
            "Mart",
            "Nisan",
            "Mayıs",
            "Haziran",
            "Temmuz",
            "Ağustos",
            "Eylül",
            "Ekim",
            "Kasım",
            "Aralık"
          ]
        }
      });
    }
    else{
      $(".departure").daterangepicker({
        opens: 'right',
        timePicker: true,
        timePicker24Hour: true,
        "autoApply": true,
        startDate : that.route.arrivalDate,
        endDate : that.route.departureDate,
        locale: {
          format: 'DD/MM/YYYY hh:mm',
          "applyLabel": "Onayla",
          "cancelLabel": "İptal",
          "daysOfWeek": [
            "Pa",
            "Pt",
            "Sa",
            "Ça",
            "Pr",
            "Cu",
            "Ct"
          ],
          "monthNames": [
            "Ocak",
            "Şubat",
            "Mart",
            "Nisan",
            "Mayıs",
            "Haziran",
            "Temmuz",
            "Ağustos",
            "Eylül",
            "Ekim",
            "Kasım",
            "Aralık"
          ]
        }
      });
    }
    $(".departure").on('apply.daterangepicker', function(ev, picker) {
      that.route.portingTime = Math.ceil(moment.duration(picker.endDate.diff(picker.startDate)).asMinutes());
      that.route.arrivalDate = picker.startDate.toDate();
      that.route.departureDate = picker.endDate.toDate();
      that.refresh += 1;
    });

  },
  watch:{
    route:{
      deep:true,
      handler:function (){
        this.showError = false;
        this.checkValid();
      }
    }
  }
}
</script>

<style scoped>

</style>